"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackEventWithHeap = exports.VALIDATE_AND_SUBMIT = exports.UPDATE_FORM_FIELD = exports.PF_CA_CHECKBOX_ERROR_EVENT = exports.CHECK_BOX_ERROR = exports.BROWSER_SUPPORT_MESSAGE = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var UPDATE_FORM_FIELD = 'UPDATE_FORM_FIELD';
exports.UPDATE_FORM_FIELD = UPDATE_FORM_FIELD;
var PF_CA_CHECKBOX_ERROR_EVENT = 'PF_CA_CHECKBOX_ERROR_EVENT';
exports.PF_CA_CHECKBOX_ERROR_EVENT = PF_CA_CHECKBOX_ERROR_EVENT;
var VALIDATE_AND_SUBMIT = 'VALIDATE_AND_SUBMIT';
exports.VALIDATE_AND_SUBMIT = VALIDATE_AND_SUBMIT;
var CHECK_BOX_ERROR = 'You must agree to the Terms & Conditions, Privacy Policies to continue';
exports.CHECK_BOX_ERROR = CHECK_BOX_ERROR;
var BROWSER_SUPPORT_MESSAGE = 'If you do not have Adobe Reader installed or full PDF support in this web browser';
exports.BROWSER_SUPPORT_MESSAGE = BROWSER_SUPPORT_MESSAGE;
var trackEventWithHeap = function trackEventWithHeap(evntNm, payload) {
  var heapCustomTrackingClient = window && window.lcTracking;
  var finalPayLoad = _objectSpread(_objectSpread({}, {
    eventName: evntNm
  }), payload);
  if (heapCustomTrackingClient && heapCustomTrackingClient.trackCustomEvent) {
    heapCustomTrackingClient.trackCustomEvent(finalPayLoad, {});
  }
};
exports.trackEventWithHeap = trackEventWithHeap;
